import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiFormatListText } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { MOBILE_NAVIGATION } from '../../keys';
import { adminMobileNavigationRoute } from '../../routes';

export interface MobileNavigationAdministrationSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const MobileNavigationAdministrationSideNavigation = ({
    isAllowed,
    ...restOfProps
}: MobileNavigationAdministrationSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(MOBILE_NAVIGATION.TITLE)}
            icon={mdiFormatListText}
            route={adminMobileNavigationRoute}
        />
    );
};

MobileNavigationAdministrationSideNavigation.displayName = 'SideNavigationItem';

export { MobileNavigationAdministrationSideNavigation };
